import React from "react"
import Checkbox from "@kit/design/checkbox"

export function ProductItem({ product, products, update }) {
  const handleClick = ev => {
    const updatedProducts = products.map(p => {
      if (p.id === product.id) {
        p.checked = ev.target.checked
      }
      return p
    })

    update({
      products: updatedProducts,
      productIds: JSON.stringify(
        updatedProducts.filter(p => p.checked).map(i => i.id)
      )
    })
  }

  return (
    <div className="flex justify-between p-4 border-t border-gray-100">
      <div className="flex">
        <div className="pr-4">
          <Checkbox
            name={`productIds[${product.id}]`}
            onChange={ev => handleClick(ev)}
            value={product.id}
            checked={product.checked}
          />
        </div>

        <div className="font-semibold text-gray-800 pr-2">{product.name}</div>
      </div>
      <div className="text-gray-600">{product.price.replace(/\s/g, "")}</div>
    </div>
  )
}

export function ProductChecklist({ products, update }) {
  return (
    <>
      <div className="text-xs mb-4">
        Select which products to show on your products page
      </div>
      <div className="rounded-lg border border-gray-100 overflow-hidden">
        <div className="flex justify-between bg-gray-100 px-4 py-2">
          <div className="text-xs font-semibold text-gray-700">NAME</div>
          <div className="text-xs">PRICE</div>
        </div>
        <div>
          {products.map(product => (
            <div key={product.id}>
              <ProductItem
                product={product}
                products={products}
                update={update}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
